import React from 'react';
import { CategoryTabs } from '../navigation/CategoryTabs';
import { LeftSidebar } from '../sidebar/LeftSidebar';
import { CenterPreview } from '../preview/CenterPreview';
import { RightPaymentPanel } from '../panel/RightPaymentPanel';

export const SinglePageLayout: React.FC = () => {
    return (
        <div className="flex flex-col h-screen overflow-hidden bg-gray-100">
            <CategoryTabs />
            <div className="flex flex-col lg:flex-row flex-1 overflow-hidden relative">
                {/* Mobile: Preview is top, Sidebar is middle (scrollable), Payment is bottom */}
                {/* Desktop: Sidebar Left, Preview Center, Payment Right */}

                {/* Left Sidebar - Desktop: Left, Mobile: Middle (scrollable content) */}
                <div className="order-2 lg:order-1 flex-1 lg:flex-none lg:h-full overflow-hidden lg:overflow-visible w-full lg:w-auto z-20">
                    <LeftSidebar />
                </div>

                {/* Center Preview - Desktop: Center, Mobile: Top */}
                <div className="order-1 lg:order-2 h-[40vh] lg:h-full lg:flex-1 relative z-10">
                    <CenterPreview />
                </div>

                {/* Right Payment Panel - Desktop: Right, Mobile: Bottom */}
                <div className="order-3 lg:order-3 h-auto lg:h-full w-full lg:w-auto z-30">
                    <RightPaymentPanel />
                </div>
            </div>
        </div>
    );
};
